/* Collection banner (shop) - behaviour. Owner: sections/main-collection-banner-shop.liquid */

(function () {
  var current = 0;
  var total = 2;
  var slides = document.getElementById('kaayu-col-slides');
  var dots = document.querySelectorAll('.kaayu-col-dot');

  function update() {
    slides.style.transform = 'translateX(-' + current * 100 + '%)';
    dots.forEach(function(d, i) {
      d.classList.toggle('active', i === current);
    });
  }

  var timer = setInterval(function () {
    current = (current + 1) % total;
    update();
  }, 4000);

  function resetTimer() {
    clearInterval(timer);
    timer = setInterval(function () {
      current = (current + 1) % total;
      update();
    }, 4000);
  }

  document.getElementById('kaayu-col-prev').addEventListener('click', function () {
    current = (current - 1 + total) % total;
    update(); resetTimer();
  });

  document.getElementById('kaayu-col-next').addEventListener('click', function () {
    current = (current + 1) % total;
    update(); resetTimer();
  });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      current = parseInt(this.getAttribute('data-index'));
      update(); resetTimer();
    });
  });
})();
